export const cheatCopy = {
    cht_layout_title: "Cheat sheets",
    cht_layout_description:
		"Cheat sheets reprenant la syntaxe de TypeScript.",
    cht_download: "Télécharger le zip",
    cht_blurb_1: "Pages de documentation de la syntaxe téléchargeables pour les différentes parties du code TypeScript utilisé couramment.",
    cht_blurb_2: "Apprenez-en plus sur les classes, les interfaces, les types et l'analyse du flux de contrôle.",

    cht_cfa: "Analyse du flux de contrôle",
    cht_interfaces: "Interfaces",
    cht_types: "Types",
    cht_classes: "Classes",
    cht_dl_title: "Télécharger les PDF et PNG",
    cht_dl_subtitle: "A lire plus tard ou à imprimer",
}
